import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementCVBBListView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        Công văn &amp; Biên bản
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will host the Công văn &amp; Biên bản list and toolbar mapped from
        {' '}
        <strong>form_frmProcurementMainSubFormCVBB.txt</strong>
        {' '}
        and
        {' '}
        <strong>form_frmProcurementQryCVBB.txt</strong>
        , including New / Edit / Delete / Copy and Pr Cam Ket / Pr BTCN actions.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

